var _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { set, computed } from '@ember/object';
import { join } from '@ember/runloop';
import Component from '@ember/component';
import { TextField } from 'field-kit'; // eslint-disable-line import/named
import ValidatedViewSupport from '@dashboard/shared-ui/mixins/validated-view-support'; // eslint-disable-line ember/no-mixins

// Since this component isn't meant to be implemented directly it does not have a template
// Example of what to put in the template:
// <Input class="input" placeholder={{@placeholder}} />
//
// FIXME (steckel): It would be more correct to have this element render an
// input element **directly**. Using a custom element of <sq-input> and have it
// render a <div> tag is counter intuitive and forces one to set work around the
// surrounding div element through a public variable of `inputClassNames` which
// leaks its internals.
let SqInputFormatted = (_class = class SqInputFormatted extends Component.extend(ValidatedViewSupport) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "field", null);
    _defineProperty(this, "inputClassNames", null);
    _defineProperty(this, "_storedValue", null);
  }
  // These functions can be overridden by child components.
  valueToStore(value) {
    return value;
  }
  valueToShow(value) {
    return value;
  }
  textFieldDidEndEditing() {
    join(() => {
      // Trigger value recomputation
      // _setFieldValue may cause the this.field.value() to change
      const oldValue = this.field.value();
      this._setFieldValue(oldValue);
      const newValue = this.field.value();
      this.set('value', this.valueToStore(newValue));
      this.onChange?.(newValue);
    });
  }
  set value(value = null) {
    if (this.field) {
      this._setFieldValue(value);
    }
    this._storedValue = value;
  }
  get value() {
    return this._storedValue ?? this.field?.value();
  }
  _getFormatter() {
    return null;
  }
  _getField() {
    const inputElement = this.element.querySelector('input');
    return new TextField(inputElement);
  }
  _setFieldValue(value) {
    // without this check, fields with a value binding trigger a
    // @value() and thus a @_setFieldValue call on keyup.
    // This is problematic because it resets the selection range,
    // sending the caret to the end of the field.
    const valueToShow = this.valueToShow(value);
    if (this.field.text() !== this.field.formatter().format(valueToShow)) {
      this.field.setValue(valueToShow);
    }
  }
  didUpdateAttrs() {
    super.didUpdateAttrs();
    this.field.setFocusedPlaceholder(this.focusedPlaceholder);
    this.field.setUnfocusedPlaceholder(this.unfocusedPlaceholder);
  }
  didInsertElement() {
    super.didInsertElement();
    const field = this._getField();
    set(this, 'field', field);
    if (this._getFormatter()) {
      field.setFormatter(this._getFormatter());
    }
    field.setDelegate(this);
    field.setFocusedPlaceholder(this.focusedPlaceholder);
    field.setUnfocusedPlaceholder(this.unfocusedPlaceholder);
    this._setFieldValue(this._storedValue);
  }
  willDestroyElement(...args) {
    super.willDestroyElement(...args);
    this.field.destroy();
  }
}, (_applyDecoratedDescriptor(_class.prototype, "value", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "value"), _class.prototype)), _class);
export { SqInputFormatted as default };